// extracted by mini-css-extract-plugin
module.exports = {"backIcon":"backIcon--M92vz"};